/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/import-whitelist
import { PRELOADED_GADGET_DATA_KEY } from '@jira/global-pages__dashboard-common/src/constants.tsx';
import type { DashboardConfigType } from '@jira/global-pages__dashboard-common/src/types.tsx';
// eslint-disable-next-line jira/import-whitelist
import { getPrefetches } from '@jira/global-pages__dashboard-common/src/utils/prefetch/main.tsx';

const generatePreloadLinkTags = (dashboardConfig: DashboardConfigType): string | null => {
	if (dashboardConfig.gadgets.length === 0) {
		return null;
	}

	const prefetches = getPrefetches(dashboardConfig);

	const preloadLinks =
		prefetches
			.map(
				(prefetch) =>
					`<link rel="preload" as="fetch" href="${prefetch.url}" crossorigin="anonymous" />`,
			)
			.join('\n') || null;

	const syncPrefetchUrls = prefetches
		.filter((prefetch) => prefetch.isSyncLoadingSupported())
		.map((prefetch) => prefetch.url);

	if (preloadLinks != null && syncPrefetchUrls.length > 0) {
		const fetchScript = `
            <script type="text/javascript" data-defer-skip>
                const preloadUrls = ${JSON.stringify(syncPrefetchUrls)};
                window['${PRELOADED_GADGET_DATA_KEY}'] = {};

                preloadUrls.forEach((preloadUrl) => {
                    fetch(preloadUrl)
                        .then(res => res.json())
                        .then(data => {
                            window['${PRELOADED_GADGET_DATA_KEY}'][preloadUrl] = data;
                        });
                });
            </script>
        `;

		return preloadLinks + fetchScript;
	}

	return preloadLinks;
};

export default generatePreloadLinkTags;
